import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';

import { RenderingContext, SitePage, WchSdkRouter } from './../../../../../api';
import { noop, pageEquals, pageFromRenderingContext } from './../../../../../utils';
import { pageGetActivePage } from './../../../../utils/page.utils';
import { li } from './../../../logger/logger.service';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'SdkRouter';

export interface SdkRouterDependencies {

    router: Router;
}

export class SdkRouter implements WchSdkRouter {

    // public APIs
    navigateByPath: (aPath: string) => PromiseLike<boolean>;

    /*
     * Returns an observable that represents the active route
     *
     * @return an observable of the currently active route
     */
    activeRoute: () => Observable<SitePage>;

    /*
     * Returns an observable that represents the active rendering context
     *
     * @return an observable of the currently active rendering context
     */
    activeRenderingContext: () => Observable<RenderingContext>;

    destroy: () => void;

    constructor(aDeps: SdkRouterDependencies) {

        // back reference
        const that = this;

        // active page
        const onActivePage: Observable<SitePage> = pageGetActivePage().pipe(
            map(pageFromRenderingContext),
            distinctUntilChanged(pageEquals),
            tap(page => li(LOGGER, 'onActivePage', '[', page, ']'))
        );

        function _navigateByPath(aPath: string): PromiseLike<boolean> {
            // log
            li(LOGGER, 'navigateByPath', aPath);
            // execute the navigation
            return aDeps.router.navigateByUrl(aPath);
        }

        /*
         * Returns an observable that represents the active route
         */
        function _activeRoute(): Observable<SitePage> {
            // log
            li(LOGGER, 'activeRoute');
            // returns the context
            return onActivePage;
        }

        /*
         * Returns an observable that represents the active rendering context
         */
        function _activeRenderingContext(): Observable<RenderingContext> {
            // log
            li(LOGGER, '_activeRenderingContext');
            // returns the context
            return pageGetActivePage();
        }

        // init the API
        that.navigateByPath = _navigateByPath;
        that.activeRoute = _activeRoute;
        that.activeRenderingContext = _activeRenderingContext;
        that.destroy = noop;
    }

}
